import { useTranslate } from "@tolgee/react";
import { Link } from "react-router-dom";

import { type ModificationRequestBreadcrumbProps } from "./ModificationRequestBreadcrumb.types";

export const ModificationRequestBreadcrumb = ({
  orderId,
  orderItemId,
}: ModificationRequestBreadcrumbProps) => {
  const { t } = useTranslate();

  return (
    <Link to={`/orders/${orderId}/order-items/${orderItemId}/edit`}>
      {t("navigation.modificationRequest")}
    </Link>
  );
};
